import size from '../modules/size';
import debounce from '../modules/debounce';

export default class AbstractSlider {
    constructor(element) {
        this.$sldier = element;
        this.states = {
            desktop: {
                name: 'desktop',
                options: this.desktopOptions,
                min: size.desktop,
                max: Infinity
            },
            tabletBig: {
                name: 'tabletBig',
                options: this.tabletBigOptions,
                min: size.tabletBig,
                max: size.desktop
            },
            tablet: {
                name: 'tablet',
                options: this.tabletOptions,
                min: size.tablet,
                max: size.tabletBig
            },
            mobileBig: {
                name: 'mobileBig',
                options: this.mobileBigOptions,
                min: size.mobileBig,
                max: size.tablet
            },
            mobile: {
                name: 'mobile',
                options: this.mobileOptions,
                min: 0,
                max: size.mobileBig
            }
        };
        this.lastState = false;
        this.initSlider();
        this.initDebounce();
    }

    get isChangeState() {
        return this.state.name !== this.lastState;
    }

    get mobileOptions() {
        return false;
    }

    get mobileBigOptions() {
        return this.mobileOptions;
    }

    get tabletOptions() {
        return false;
    }

    get tabletBigOptions() {
        return this.tabletOptions;
    }

    get desktopOptions() {
        return false;
    }

    get state() {
        for (let key in this.states) {
            if (window.innerWidth >= this.states[key].min && window.innerWidth < this.states[key].max) {
                return this.states[key];
            }
        }
    }

    destroy() {
        this.$sldier.slick('unslick');
    }

    checkInit() {
        return this.$sldier.hasClass('slick-initialized');
    }

    setLastState() {
        this.lastState = this.state.name;
    }

    initSlider() {
        if (this.state.options !== false) {
            this.$sldier.slick(this.state.options);
        }
        this.setLastState();
    }

    reRenderSlider() {
        if (!this.isChangeState) {
            return;
        }
        if (this.checkInit()) {
            this.destroy();
        }
        this.initSlider();
    }

    initDebounce() {
        debounce.setResizeDebounce(() => {
            this.reRenderSlider();
        });
    }
}



// WEBPACK FOOTER //
// ./modules/slider.js